import { CompanyGroup } from './CompanyGroup.model';
import { Company } from './Company.model';
// import { ExcellenceCenter } from './ExcellenceCenter.model';
// import { Industry } from './Industry.model';
import * as _ from 'lodash';
import { Responsible } from "./Responsible.model";

export interface ProjectHashtrack {
  _id: string;
  name: string;
  companyId: string;
//   excellenceCenters: ExcellenceCenter[];
  projectExpense: boolean;
  active: boolean;
}

interface CustomerBrand {
  checkd: boolean;
  observation: string;
}

interface ConsultantRequest {
  checkd: boolean;
  observation: string;
}

export class FinesAndInterest {
    status = 0;
}
class DateEnd {
    date: string;
    indefinitePeriod = false
}

class ReadjustmentDate {
    date: string;
    notApplicable = true;
}

class DaysForNotificationOfReadjustment {
    days = 60;
    notApplicable = true;
}

export class InventoryContractType {
    _id: string;
    name: string;
    active: boolean;
}

export class CompanyInventoryModel {
  _id: string;
  companyGroup: CompanyGroup = new CompanyGroup();
  customer: Company = new Company();
  project: ProjectHashtrack = {} as ProjectHashtrack;
  startDate: string;
  dateEnd = new DateEnd();
  contractType: InventoryContractType = new InventoryContractType();
  readjustmentDate = new ReadjustmentDate();
  daysForNotificationOfReadjustment = new DaysForNotificationOfReadjustment();
  readjustmentIndex = 0;
  closingNotificationDays = 30;
//   excellenceCenterResponsible = new Responsible();
//   industryResponsible = new Responsible();
  trademarkUsageClause: CustomerBrand = {
    checkd: false,
    observation: ''
  } as CustomerBrand;
  consultantRequest: ConsultantRequest = {
    checkd: false,
    observation: ''
  } as ConsultantRequest;
  active: boolean = true;
  Files: string[] = [];
  observation: string;
//   excellenceCenter = new ExcellenceCenter();
//   industry = new Industry();
  finesAndInterests = 0;
  interes: number;
  penalty: number;

  constructor(data?: any) {
    this.populate(data);
  }

  populate(data: any) {
    _.forOwn(data, (value, key) => {
      this[key] = value;
    });
  }


loadCompanyForGrid(r: any) {
  if (r._id)
      this._id = r._id;

  if (r.customer)
      this.customer = r.customer

  if (r.companyGroup)
      this.companyGroup = r.companyGroup

  if (r.contractType)
      this.contractType = r.contractType

  if (r.readjustmentIndex)
      this.readjustmentIndex = r.readjustmentIndex;

//   if (r.excellenceCenter)
//       this.excellenceCenter = r.excellenceCenter;

//   if (r.excellenceCenterResponsible)
//       this.excellenceCenterResponsible = r.excellenceCenterResponsible;

//   if (r.industryResponsible)
//       this.industryResponsible = r.industryResponsible;

//   if (r.industry)
//       this.industry = r.industry;

  if (r.startDate)
    this.startDate = r.startDate;

  if (r.project)
    this.project = r.project;

  if (r.dateEnd)
    this.dateEnd = r.dateEnd;

  if (r.readjustmentDate)
    this.readjustmentDate = r.readjustmentDate;

  if (r.daysForNotificationOfReadjustment)
    this.daysForNotificationOfReadjustment = r.daysForNotificationOfReadjustment;

  if (r.closingNotificationDays)
    this.closingNotificationDays = r.closingNotificationDays;

  if (r.trademarkUsageClause)
    this.trademarkUsageClause = r.trademarkUsageClause;

  if (r.observation)
    this.observation = r.observation;

  if (r.finesAndInterests)
    this.finesAndInterests = r.finesAndInterests;

  if (r.interes)
    this.interes = r.interes;

  if (r.active !== undefined)
      this.active = r.active;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/CompanyInventory.model.ts